import { render, staticRenderFns } from "./GoodReturnOrder.vue?vue&type=template&id=5384079d&"
import script from "./GoodReturnOrder.vue?vue&type=script&lang=js&"
export * from "./GoodReturnOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports